<template>
    <pop-form v-if="state" width="600px">
        <div slot="title">
            设置会员价格
            <i class="el-icon-close fr" @click="$emit('stateChange', false)"></i>
        </div>
        <div class="cateBody">
            <div class="line">
                <div class="label" v-if="proData.type == 1 || proData.type == 2">
                    <span v-if="proType === 1">服务类别：</span>
                    <span v-else-if="proType === 2">产品类别：</span>
                    <span v-else-if="proType === 5">卡项类别：</span>
                </div>
                <div class="label" v-else-if="proData.type == 3">
                    <span v-if="proType === 1">服务项目：</span>
                    <span v-else-if="proType === 2">产品：</span>
                    <span v-else-if="proType === 5">卡项：</span>
                </div>
                <div class="data">{{proData.title}}</div>
            </div>
            <div class="line">
                <div class="label">选择优惠方式：</div>
                <div class="data">
                    <el-radio-group v-model="discount_mode">
                        <el-radio :label="1">折扣</el-radio>
                        <el-radio :label="2">指定价格</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <el-table :data="listData" style="width: 100%">
                <el-table-column
                        prop="vip_name"
                        label="会员类型"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="discount_data"
                        :label="discount_mode == 1 ? '折扣' : '价格'">
                    <template slot-scope="scope">
                        <div class="input-grey-append">
                            <el-input placeholder="" v-model="scope.row.discount_data">
                                <template slot="append">{{discount_mode == 1 ? '折' : '元'}}</template>
                            </el-input>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="foot" class="foot-box">
            <el-button size="medium" @click="cancelSave">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
        </div>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "EditProductCategoryDiscount",
        components: {PopForm},
        props: {
            state: {
                type: Boolean,
                default: true
            },
            proType: {
                type: Number,
                default: 0        //项目1，商品2
            },
            proData: {
                type: Object,
                default: {
                    id: null,
                    type: null,     //折扣类型：1 所有，2 分类， 3 项目|商品
                    title: null,
                    thumb: null,
                    price: null,
                }
            },
        },
        model: {
            prop: "state",
            event: "stateChange"
        },
        data: () => ({
            discount_mode: 1,
            listData: [],
            remoteData: [],
        }),
        mounted: function () {

        },
        methods: {
            //获取折扣数据
            getDiscountData: function () {
                obj.postData("store_vip/get_discount_data", {
                    pro_type: this.proType,
                    dis_type: this.proData.type,
                    dis_id: this.proData.id
                }, res => {
                    if(res.errcode === 0){
                        this.listData = res.data;
                        this.remoteData = res.data;
                        if(res.data.length > 0){
                            this.discount_mode = parseInt(res.data[0].discount_mode);
                        }
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            submitSave: function () {
                let setData = {
                    pro_type: this.proType,
                    dis_type: this.proData.type,
                    dis_id: this.proData.id,
                };

                let disData = [];
                this.listData.forEach( v => {
                    disData.push({
                        vip_id: v.vip_id,
                        mode: this.discount_mode,
                        value: v.discount_data
                    });
                });

                setData.dis_data = JSON.stringify(disData);

                obj.postData("store_vip/set_discount_data", setData, res => {
                    if(res.errcode === 0) {
                        obj.message.success("设置成功");
                        this.$emit("done"    );
                    }else
                        obj.message.error(res.errdesc);

                    this.$emit("stateChange", false);
                });
            },
            cancelSave: function () {
                this.$emit("stateChange", false);
            }
        },
        watch: {
            state: function (data) {
                if(data){
                    this.getDiscountData();
                }
            },
            discount_mode: function (mode) {
                let remoteMode = this.remoteData[0].discount_mode;
                if(mode != remoteMode) {
                    let listData = [];
                    this.remoteData.forEach(v => {
                        listData.push({
                            discount_data: "",
                            discount_mode: mode,
                            vip_id: v.vip_id,
                            vip_name: v.vip_name,
                        });
                    });
                    this.listData = listData;
                }else
                    this.listData = this.remoteData;
            }
        }
    }
</script>

<style scoped>
    .listBox{
        height: 300px;
        overflow: auto;
    }
    .listBox>.item{
        width: 33.33%;
        float: left;
        text-align: center;
    }
    .item>input{
        width: 168px;
        height: 40px;
        border-radius: 3px;
        border: solid 1px #dcdfe6;
        line-height: 40px;
        text-align: center;
    }
    .line{
        height: 35px;
        line-height: 35px;
    }
    .line>.label{
        width: 110px;
        text-align: right;
        float: left;
    }

</style>
